<template>
    <div :class="{ 'form-item-button':['querybutton', 'addbutton', 'otherbutton'].includes(item.mold) }">
        <template v-if="item.mold === 'querybutton'">
            <el-button
                v-bind="item"
                :loading="loading"
                :disabled="disableds[item.prop || item.mold]"
                class="query-button"
                :class="{ 'query-button-icon': item.type === 'icon'}"
                @click="$emit('query-click')"
            >
                <template v-if="item.type !== 'icon'">
                    {{ item.name || '查询' }}
                </template>
            </el-button>
        </template>

        <template v-if="item.mold === 'addbutton'">
            <el-button
                v-bind="item"
                :disabled="disableds[item.prop || item.mold]"
                class="add-button"
                :class="{ 'add-button-icon': item.type === 'icon'}"
                @click="$emit('add-click')"
            >
                <template v-if="item.type !== 'icon'">
                    {{ item.name || '新增' }}
                </template>
            </el-button>
        </template>

        <template v-if="item.mold === 'otherbutton'">
            <el-button
                v-bind="item"
                :disabled="disableds[item.prop || item.mold]"
                :icon="item.type === 'icon' ? item.icon : undefined"
                class="other-button"
                :class="{ 'other-button-icon': item.type === 'icon'}"
                @click="$emit('other-click')"
            >
                <template v-if="item.type !== 'icon'">
                    {{ item.name || '' }}
                </template>
            </el-button>
        </template>

        <template v-else-if="item.mold === 'advance'">
            <AdvanceDefaultQuerySwtich
                v-model="value[item.prop || item.mold]"
                v-bind="item"
                :reset.sync="resets[item.prop || item.mold]"
                :disabled="disableds[item.prop || item.mold]"
                @advance="$emit('advance', value[item.prop || item.mold])"
            />
        </template>

        <template v-else-if="SUPPORT_TYPE.includes(item.mold)">
            <el-form-item
                :label="item.name"
                :prop="item.prop"
            >
                <span v-if="item.tips" slot="label">
                    <span>{{ item.name }}</span>
                    <el-tooltip
                        effect="light"
                        placement="right-start"
                    >
                        <div slot="content" v-html="item.tips" />
                        <img
                            :src="tipsSrc"
                            alt=""
                            class="tipsImg"
                        >
                    </el-tooltip>
                </span>
                <template v-if="item.label" slot="label">
                    <span class="custom-label" v-html="item.label"></span>
                </template>
                <!-- 多个 -->
                <template v-if="Array.isArray(item.link)">
                    <component
                        :is="`${item.mold}-custom`"
                        :key="item.prop"
                        v-model="value[item.prop]"
                        v-bind="item"
                        :reset.sync="resets[item.prop]"
                        :disabled="disableds[item.prop]"
                        :popper-class="popperClass"
                        v-on="item.listeners"
                        @after-leave="$emit('after-leave', item.prop)"
                        @enter-click="$emit('enter-click')"
                    />
                    <template v-for="link in item.link">
                        <template v-if="link.mold">
                            <span
                                v-show="link.name"
                                :key="`${link.prop}-${link.name}`"
                                class="form-item-name form-item-name-link"
                                v-html="link.name"
                            />
                            <component
                                :is="`${link.mold}-custom`"
                                v-if="link.renderable === false ? false : true"
                                :key="link.prop"
                                v-model="value[link.prop]"
                                v-bind="link"
                                :reset.sync="resets[link.prop]"
                                :disabled="disableds[link.prop]"
                                :popper-class="popperClass"
                                v-on="link.listeners"
                                @after-leave="$emit('after-leave', link.prop)"
                                @enter-click="$emit('enter-click')"
                            />
                        </template>
                    </template>
                </template>
                <!-- 单个 -->
                <template v-else-if="item.link &&item.link.mold">
                    <template v-if="item.link.position === 'after'">
                        <component
                            :is="`${item.link.mold}-custom`"
                            v-if="item.link.renderable === false ? false : true"
                            :key="item.link.prop"
                            v-model="value[item.link.prop]"
                            v-bind="item.link"
                            :reset.sync="resets[item.link.prop]"
                            :disabled="disableds[item.link.prop]"
                            :popper-class="popperClass"
                            v-on="item.link.listeners"
                            @after-leave="$emit('after-leave', item.link.prop)"
                            @enter-click="$emit('enter-click')"
                        />
                        <span

                            v-show="item.link.name"
                            class="form-item-name form-item-name-link"
                            v-html="item.link.name"
                        />
                        <component
                            :is="`${item.mold}-custom`"
                            :key="item.prop"
                            v-model="value[item.prop]"
                            v-bind="item"
                            :reset.sync="resets[item.prop]"
                            :disabled="disableds[item.prop]"
                            :popper-class="popperClass"
                            v-on="item.listeners"
                            @after-leave="$emit('after-leave', item.prop)"
                            @enter-click="$emit('enter-click')"
                        />
                    </template>
                    <template v-else>
                        <component
                            :is="`${item.mold}-custom`"
                            :key="item.prop"
                            v-model="value[item.prop]"
                            v-bind="item"
                            :reset.sync="resets[item.prop]"
                            :disabled="disableds[item.prop]"
                            :popper-class="popperClass"
                            v-on="item.listeners"
                            @after-leave="$emit('after-leave', item.prop)"
                            @enter-click="$emit('enter-click')"
                        />
                        <span

                            v-show="item.link.name"
                            class="form-item-name form-item-name-link"
                            v-html="item.link.name"
                        />
                        <component
                            :is="`${item.link.mold}-custom`"
                            v-if="item.link.renderable === false ? false : true"
                            :key="item.link.prop"
                            v-model="value[item.link.prop]"
                            v-bind="item.link"
                            :reset.sync="resets[item.link.prop]"
                            :disabled="disableds[item.link.prop]"
                            :popper-class="popperClass"
                            v-on="item.link.listeners"
                            @after-leave="$emit('after-leave', item.link.prop)"
                            @enter-click="$emit('enter-click')"
                        />
                    </template>
                </template>

                <template v-else>
                    <component
                        :is="`${item.mold}-custom`"
                        :key="item.prop"
                        v-model="value[item.prop]"
                        v-bind="item"
                        :reset.sync="resets[item.prop]"
                        :disabled="disableds[item.prop]"
                        :popper-class="popperClass"
                        v-on="item.listeners"
                        @after-leave="$emit('after-leave', item.prop)"
                        @enter-click="$emit('enter-click')"
                    />
                </template>
                </span>
            </el-form-item>
        </template>
    </div>
</template>

<script>
import tipsSrc from "@/assets/img/tips.png";
import { SUPPORT_TYPE, components } from "./configs";

export default {
  name: "FormCustomBaseItem",

  components,

  inheritAttrs: false,

  props: {
    item: {
      default: () => ({}),
      type: Object
    },

    loading: {
      default: false,
      type: Boolean
    },

    resets: {
      default: () => ({}),
      type: Object
    },

    disableds: {
      default: () => ({}),
      type: Object
    },
    popperClass: {
      type: String,
      default: ""
    },

    value: {
      default: () => ({}),
      type: Object
    }
  },

  data() {
    return {
      tipsSrc,
      SUPPORT_TYPE
    };
  }
};
</script>
